Apt.fn.make('panel', {
	/**
	 * Setup module
	 *
	 * @param {Object} options
	 */
	init(options) {
		if (window.crawler) {
			return;
		}

		const scope = this;

		scope.index = null;
		scope.conf = options;

		scope.$private.bind();
	},

	/**
	 * Check panel status
	 *
	 * @returns {Boolean}
	 */
	opened() {
		return this.open === true;
	},

	/**
	 * Close panel
	 */
	close() {
		window.history.go(($.history.index() - this.index) * -1);
	},

	/**
	 * Hide panel
	 */
	hide() {
		const scope = this;

		if (! scope.open) {
			return;
		}

		scope.index = null;
		scope.open = false;

		const conf = scope.conf;

		$.set('context', scope.context, {
			trigger: false
		});

		if (conf.$mask) {
			conf.$mask.off('click');

			conf.$mask.remove();

			conf.$mask = null;
		}

		LS.util.uncrop();

		const panel = $$('panel')[0];

		panel.classList.remove('-is-loaded');

		LS.util.focus(scope.active);

		panel.setAttribute('aria-hidden', 'true');
		panel.removeAttribute('aria-labelledby');

		$.exec(conf.closed);

		// Timeout to address Chrome bug
		setTimeout(() => {
			$('.js-replace').empty();
		});
	},

	/**
	 * Trigger panel event
	 *
	 * @param {HTMLElement} el
	 * @param {String} [url]
	 */
	trigger(el, url) {
		const scope = this;
		const conf = scope.conf;
		const $panel = $$('panel');
		const $inner = $$('panelInner', $panel);

		let init;
		let error;
		let opened;

		$.history.go({
			path: url || el.href,
			partials: 'title, .js-replace, .js-context',
			processErrors: false,
			scrollTarget: $inner,
			scrollTop: 0,
			begin: obj => {
				error = false;
				opened = scope.open;

				scope.open = true;

				obj.partials = 'title, .js-replace, .js-context'; // TODO investigate

				if (scope.index === null) {
					init = true;

					scope.locked = true;

					$.exec(conf.opening, {
						args: el
					});

					scope.index = $.history.index();
					scope.context = $.context();
				}
			},
			replace: () => {
				scope.locked = false;

				if (init) {
					init = false;

					$panel[0].classList.add('-is-loaded');

					$panel[0].setAttribute('aria-hidden', 'false');
					$panel[0].setAttribute('aria-labelledby', 'panel-title');

					scope.$private.mask();

					LS.util.crop();

					$.exec(conf.opened, {
						args: el
					});

					const focusable = $('a, button, input, select, textarea', $inner);

					if (focusable.length) {
						scope.active = document.activeElement;

						LS.util.focus(focusable[0]);
					}
				}

				$inner.scrollTop(0);
			},
			unload: obj => {
				if (obj.event === 'pop' && obj.index <= scope.index) {
					scope.hide();
				}
			},
			request: {
				error: xhr => {
					scope.locked = false;

					if (! opened) {
						scope.index = null;
						scope.open = false;
					}

					LS.common.transition(true);

					let message = 'Unable to load — please try again';

					try {
						message = JSON.parse(xhr.responseText).message;
					} catch (e) {
						//
					}

					LS.util.warn(message);
				}
			}
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		$.events.reset('panel');
	}
}, {
	/**
	 * Bind links
	 */
	bind() {
		const pub = this.$public;

		$.events.on('a', 'click', (e, el) => {
			if (e.metaKey || el.target === '_blank' || ! /https?:/.test(el.href)) {
				return;
			}

			const segments = $.routes.parse(el.href).segments;

			if (
				segments[0] === 'properties' &&
				LS.filters.isEntry(segments[2] || '')
			) {
				pub.trigger(el);

				e.preventDefault();
				e.stopPropagation();

				return;
			}

			pub.hide();
		}, {
			delegate: '$wrapper',
			namespace: 'panel'
		});

		$$('panelClose').on('click', () => {
			pub.close();
		}, {
			namespace: 'panel'
		});

		$(document).on('keydown', e => {
			if (e.keyCode === 27) {
				if (
					! pub.open ||
					pub.locked ||
					LS.modal.opened()
				) {
					return;
				}

				pub.close();
			}
		}, {
			namespace: 'panel'
		});
	},

	/**
	 * Create panel mask
	 */
	mask() {
		const pub = this.$public;
		const conf = pub.conf;

		if (conf.$mask) {
			return;
		}

		conf.$mask = $('<div class="panel__mask"/>');

		conf.$mask.on('click', () => {
			pub.close();
		}, {
			namespace: 'panel'
		})
			.appendTo(document.body);
	}
});